export enum ExpanderSize {
  small = 'small',
  large = 'large',
}
